<mat-card class="crud-search-card">
  <mat-card-title>{{getEditorTitle()}}</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">



        <mat-form-field matTooltip="Ammunition Stock Event Type"
          [matTooltipDisabled]="disabledTooltip(this.ammunitionStockEventType)">
          <mat-label i18n="@@type.AmmunitionStockEvent.eventType">Event Type</mat-label>
          <mat-select formControlName="ammunitionStockEventType" id="ammunitionStockEventTypeFilterSelectInput"
            (ngModelChange)="ammunitionStockEventTypeChanging($event)" [(ngModel)]="ammunitionStockEventTypeFilter"
            (ngModelChange)="ammunitionStockEventTypeChanged($event)" #ammunitionStockEventTypeFilterSelectInput
            placeholder="Event Type">
            <mat-option>Any</mat-option>
            <mat-option value="Stocktake">
              Stocktake
            </mat-option>
            <mat-option value="Addition">
              Additions
            </mat-option>
            <mat-option value="Issue">
              Issue
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- 
        <mat-form-field matTooltip="Select a Ranger from the list" [matTooltipDisabled]="disabledTooltip(this.ranger)">
          <mat-label i18n="@@type.AmmunitionStockEvent.ranger">Ranger</mat-label>
          <mat-select formControlName="ranger" id="rangerFilterInput"              
              (ngModelChange)="rangerChanging($event)" [(ngModel)]="rangerFilter"              
              (ngModelChange)="rangerChanged($event)" #rangerFilterInput              
              placeholder="Ranger" [compareWith]="rangerCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let ranger of rangerSelectionList" [value]="ranger">
              {{rangerDisplay(ranger)}}
            </mat-option>
          </mat-select>
        </mat-form-field> -->

        <mat-form-field matTooltip="Event Date From"
          [matTooltipDisabled]="disabledTooltip(this.eventDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.AmmunitionStockEvent.eventDateGreaterThanOrEqualTo">Event Date From</mat-label>
          <input matInput formControlName="eventDateGreaterThanOrEqualTo" id="eventDateGreaterThanOrEqualToFilterInput"
            (ngModelChange)="eventDateGreaterThanOrEqualToChanging($event)"
            [(ngModel)]="eventDateGreaterThanOrEqualToFilter"
            (ngModelChange)="eventDateGreaterThanOrEqualToChanged($event)" #eventDateGreaterThanOrEqualToFilterInput
            [matDatepicker]="eventDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
            placeholder="Event Date From">
          <mat-datepicker-toggle matSuffix [for]="eventDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #eventDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
        <mat-form-field matTooltip="Event Date To"
          [matTooltipDisabled]="disabledTooltip(this.eventDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.AmmunitionStockEvent.eventDateLessThanOrEqualTo">Event Date To</mat-label>
          <input matInput formControlName="eventDateLessThanOrEqualTo" id="eventDateLessThanOrEqualToFilterInput"
            (ngModelChange)="eventDateLessThanOrEqualToChanging($event)" [(ngModel)]="eventDateLessThanOrEqualToFilter"
            (ngModelChange)="eventDateLessThanOrEqualToChanged($event)" #eventDateLessThanOrEqualToFilterInput
            [matDatepicker]="eventDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
            placeholder="Event Date To">
          <mat-datepicker-toggle matSuffix [for]="eventDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #eventDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
        <!-- 
        <mat-form-field matTooltip="Comments" [matTooltipDisabled]="disabledTooltip(this.comments)">
          <mat-label i18n="@@type.AmmunitionStockEvent.comments">Comments</mat-label>
          <input matInput formControlName="comments" id="commentsFilterInput"              
              (ngModelChange)="commentsChanging($event)" [(ngModel)]="commentsFilter"              
              (ngModelChange)="commentsChanged($event)" #commentsFilterInput              
              maxlength="255" placeholder="Comments">
        </mat-form-field> -->

        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.AmmunitionStockEvent.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdByFilterInput"
            (ngModelChange)="createdByChanging($event)" [(ngModel)]="createdByFilter"
            (ngModelChange)="createdByChanged($event)" #createdByFilterInput maxlength="255" placeholder="Created By">
        </mat-form-field>

      </div>

      <div class="search-section">

        <mat-form-field matTooltip="Created Date From"
          [matTooltipDisabled]="disabledTooltip(this.createdDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.AmmunitionStockEvent.createdDateGreaterThanOrEqualTo">Created Date From</mat-label>
          <input matInput formControlName="createdDateGreaterThanOrEqualTo"
            id="createdDateGreaterThanOrEqualToFilterInput"
            (ngModelChange)="createdDateGreaterThanOrEqualToChanging($event)"
            [(ngModel)]="createdDateGreaterThanOrEqualToFilter"
            (ngModelChange)="createdDateGreaterThanOrEqualToChanged($event)" #createdDateGreaterThanOrEqualToFilterInput
            [matDatepicker]="createdDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
            placeholder="Created Date From">
          <mat-datepicker-toggle matSuffix [for]="createdDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Created Date To"
          [matTooltipDisabled]="disabledTooltip(this.createdDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.AmmunitionStockEvent.createdDateLessThanOrEqualTo">Created Date To</mat-label>
          <input matInput formControlName="createdDateLessThanOrEqualTo" id="createdDateLessThanOrEqualToFilterInput"
            (ngModelChange)="createdDateLessThanOrEqualToChanging($event)"
            [(ngModel)]="createdDateLessThanOrEqualToFilter"
            (ngModelChange)="createdDateLessThanOrEqualToChanged($event)" #createdDateLessThanOrEqualToFilterInput
            [matDatepicker]="createdDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
            placeholder="Created Date To">
          <mat-datepicker-toggle matSuffix [for]="createdDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Quantity From"
          [matTooltipDisabled]="disabledTooltip(this.quantityGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.AmmunitionStockEvent.quantityGreaterThanOrEqualTo">Quantity From</mat-label>
          <input matInput formControlName="quantityGreaterThanOrEqualTo" id="quantityGreaterThanOrEqualToFilterInput"
            (ngModelChange)="quantityGreaterThanOrEqualToChanging($event)"
            [(ngModel)]="quantityGreaterThanOrEqualToFilter"
            (ngModelChange)="quantityGreaterThanOrEqualToChanged($event)" #quantityGreaterThanOrEqualToFilterInput
            type="number" placeholder="Quantity From">
        </mat-form-field>
        <mat-form-field matTooltip="Quantity To" [matTooltipDisabled]="disabledTooltip(this.quantityLessThanOrEqualTo)">
          <mat-label i18n="@@type.AmmunitionStockEvent.quantityLessThanOrEqualTo">Quantity To</mat-label>
          <input matInput formControlName="quantityLessThanOrEqualTo" id="quantityLessThanOrEqualToFilterInput"
            (ngModelChange)="quantityLessThanOrEqualToChanging($event)" [(ngModel)]="quantityLessThanOrEqualToFilter"
            (ngModelChange)="quantityLessThanOrEqualToChanged($event)" #quantityLessThanOrEqualToFilterInput
            type="number" placeholder="Quantity To">
        </mat-form-field>

      </div>

      <div class="search-section export-section">
        <mat-form-field class="field-quarter-width">
          <mat-label i18n="@@actions.reportRun.format">Format</mat-label>
          <mat-select [(ngModel)]="reportRun.outputFormat" formControlName="outputFormat" id="outputFormat"
            name="outputFormat" required>
            <mat-option *ngFor="let outputFormat of reportRun.outputFormats" [value]="outputFormat">
              {{outputFormat.name | refDecode:'REPORT_OUTPUT_FORMAT' | async }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span>
          <mat-checkbox [(ngModel)]="reportRun.download" formControlName="download" id="download" name="download"
            class="field-quarter-width" labelPosition="after" disabled="{{reportRun.outputFormat?.downloadOnly}}"
            i18n="@@actions.reportRun.download">Download
          </mat-checkbox>
        </span>

        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch" [ngModelOptions]="{standalone: true}">
          Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>

        <button mat-raised-button color="primary" class="action-button" (click)="exportAction()" type="button"
          i18n="@@actions.reportRun" [disabled]="!isExportEnabled()">Export</button>


        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>

    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" matSortDisableClear cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="ammunitionStockEventId">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStockEventId')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AmmunitionStockEvent.ammunitionStockEventId">
              Ammunition Stock Event Id
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.ammunitionStockEventId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ammunitionStock.ammunitionStockId">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStock.ammunitionStockId')"
              *matHeaderCellDef mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AmmunitionStockEvent.ammunitionStock">
              Ammunition Stock
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.ammunitionStock?.ammunitionStockId}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ammunitionStockDescription">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStockDescription')"
              *matHeaderCellDef cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-smallx2"
              i18n="@@type.AmmunitionStockEvent.ammunitionStockDescription">
              Ammunition Stock
            </mat-header-cell>
            <mat-cell class="search-column-smallx2" *matCellDef="let element">
              {{ammunitionStockDisplay(element.ammunitionStock)}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ranger.rangerId">
            <mat-header-cell [crud-column-header]="columns.column('ranger.rangerId')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AmmunitionStockEvent.ranger">
              Ranger
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.ranger?.name}} {{element.acknowledged ? '' : '(Not Acknowledged)'}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="acknowledged">
            <mat-header-cell [crud-column-header]="columns.column('acknowledged')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.acknowledged">
                Acknowledged 
              </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element">
              <mat-icon *ngIf="element.acknowledged">check_box</mat-icon><mat-icon *ngIf="!element.acknowledged">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="dateAcknowledged">
            <mat-header-cell [crud-column-header]="columns.column('dateAcknowledged')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.dateAcknowledged">
                Date Acknowledged 
              </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element">
              {{element.dateAcknowledged | uimDateTimeFormat}}
            </mat-cell>
          </ng-container> 

          <ng-container matColumnDef="ammunitionStockEventType">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStockEventType')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-verysmall"
              i18n="@@type.AmmunitionStockEvent.ammunitionStockEventTypeShort">
              Event Type
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element">
              {{element.ammunitionStockEventType}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="comments">
            <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AmmunitionStockEvent.comments">
              Comments
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element" [matTooltip]="element.comments">
              {{element.comments}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AmmunitionStockEvent.createdBy">
              Created By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AmmunitionStockEvent.createdDate">
              Created Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="eventDate">
            <mat-header-cell [crud-column-header]="columns.column('eventDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AmmunitionStockEvent.eventDate">
              Event Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
                {{element.eventDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="quantity">
            <mat-header-cell [crud-column-header]="columns.column('quantity')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-tiny"
              i18n="@@type.AmmunitionStockEvent.quantity">
              Quantity
            </mat-header-cell>
            <mat-cell class="search-column-tiny" *matCellDef="let element">
              <span class="right-align">
                {{element.ammunitionStockEventType == 'Issue' ? '- ' : element.ammunitionStockEventType == 'Addition' ?
                '+ ' : ''}}
                {{element.quantity | number:'1.0-2':'en-GB'}}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
                id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)"
                mat-raised-button color="primary" [routerLink]="viewRoute(element)" i18n="@@actions.view"
                id="actions.view">View</button>

              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>       
             
                <button class="action-button" mat-raised-button color="primary" (click)="acknowledgeManual(element)" *ngIf="allowsAcknowledge(element)" type="button"
                i18n="@@actions.acknowledge" id="actions.acknowledge">
                Acknowledge
              </button>

              <button class="action-button" *ngIf="allowsEditComments(element)" mat-raised-button color="primary" (click)="editComments(element)"
              type="button" i18n="@@actions.comments" id="actions.comments">
                Comments
              </button>

              <button  class="action-button" *ngIf="allowsJustfoneDebug(element)" mat-raised-button color="primary" (click)="openJustfoneDebugDialog(element)">Justfone Debug</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary"
        [routerLink]="createRoute()" [queryParams]="createRouteQueryParams()" i18n="@@actions.create"
        id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>

      
    </div>
  </mat-card-content>
</mat-card>